import { Observable, defer, firstValueFrom } from 'rxjs';

import { ApiResponse, extractCollectionData, extractNextCursor } from '../../models/auth/auth-session.model';

export function collectPaginatedData<T>(
  requestPage: (cursor?: string) => Observable<ApiResponse<unknown>>
): Observable<T[]> {
  return defer(async () => {
    const items: T[] = [];
    const seenCursors = new Set<string>();
    let cursor: string | undefined;

    for (;;) {
      const response = await firstValueFrom(requestPage(cursor));
      items.push(...extractCollectionData<T>(response));

      const nextCursor = extractNextCursor(response);
      if (!nextCursor || seenCursors.has(nextCursor)) {
        break;
      }

      seenCursors.add(nextCursor);
      cursor = nextCursor;
    }

    return items;
  });
}
